import { Page } from '@/core/architecture'

import { NftItemDetailTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * NftItemDetail Page
 * Implemented as a practical sample.
 */
export const NftItemDetail: Page = () => {
  const { state, actions } = useViewModel()

  return <NftItemDetailTemplate state={state} {...actions} />
}
